import { equals } from '@execonline-inc/collections';
import { AlreadyTranslated } from '@execonline-inc/translations';
import { Maybe, just } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import ModalStore from '../../../../../../../../Modal/Store';
import { LearningDesignResource } from '../../../../../../../Types';
import Details from './Details';
import { learningDesignCardStyle } from '../Selection';
import Competencies from './Competencies';
import IncludedExperiences from './IncludedExperiences';
import LeadingInstitutions from './LeadingInstitutions';

interface Props {
  learningDesignResource: LearningDesignResource;
  learningDesignId: Maybe<number>;
  setLearningDesignId: (id: Maybe<number>) => void;
  dataIntercomTarget?: string;
}

class FilteredLearningDesign extends React.Component<Props> {
  learningCollectionModalStore: ModalStore = new ModalStore();

  render() {
    const { learningDesignResource, learningDesignId, setLearningDesignId, dataIntercomTarget } =
      this.props;
    const { id, name, description, experiences, schoolPartners } = learningDesignResource.payload;

    return (
      <>
        <div className="drop-shadow" data-intercom-target={dataIntercomTarget}>
          <label
            onClick={() => setLearningDesignId(just(id))}
            className={learningDesignCardStyle(learningDesignId, learningDesignResource)}
          >
            <input
              type="radio"
              name="selectedLearningDesign"
              value={id}
              className="mt-1 inline-block h-5 w-5 text-teal-600"
              checked={learningDesignId.map(equals(id)).getOrElseValue(false)}
              readOnly
            />
            <div className="ml-4 flex w-full justify-between">
              <div>
                <h3 className="text-lg font-semibold">
                  <AlreadyTranslated content={name} />
                </h3>
                <p className="text-gray-700">{description}</p>
              </div>
              <div className="flex sm:flex-col">
                <IncludedExperiences
                  modalStore={this.learningCollectionModalStore}
                  experiences={experiences}
                />
                <div className="pr-4 text-center text-4xl font-thin text-gray-200">|</div>
                <LeadingInstitutions
                  experiencesSchoolPartners={schoolPartners}
                  modalStore={this.learningCollectionModalStore}
                />
                <div className="pr-4 text-center text-4xl font-thin text-gray-200">|</div>
                <Competencies
                  learningDesignResource={learningDesignResource}
                  modalStore={this.learningCollectionModalStore}
                />
              </div>
            </div>
          </label>
        </div>
        <Details modalStore={this.learningCollectionModalStore} resource={learningDesignResource} />
      </>
    );
  }
}

export default observer(FilteredLearningDesign);
